import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.98 6L9 12.77V8H6v10h10v-3h-4.85L18 8.03z"
}), 'TransitEnterexitTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TransitEnterexitTwoTone.js
// module id = 6913
// module chunks = 2